<template>
  <div class="sign-page">
    <div v-if="!isLoggedIn" class="login-container">
      <LoginSign @login-success="handleLoginSuccess" />
    </div>
    <div v-else class="qrcode-container">
      <DynamicQrcodeDisplay :sign-info="signInfo" />
    </div>
  </div>
</template>

<script>
import LoginSign from './sign-component/LoginSign'
import DynamicQrcodeDisplay from './sign-component/DynamicQrcodeDisplay'

export default {
  name: 'SignPage',
  components: {
    LoginSign,
    DynamicQrcodeDisplay
  },
  data () {
    return {
      isLoggedIn: false,
      signInfo: null
    }
  },
  created () {
    // 从URL获取签到ID
    const signId = this.$route.query.signId
    if (!signId) {
      this.$message.error('缺少签到ID参数')
    }
  },
  methods: {
    handleLoginSuccess (data) {
      this.signInfo = data
      this.isLoggedIn = true
    }
  }
}
</script>

<style lang="scss">
.sign-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;

  .login-container,
  .qrcode-container {
    width: 100%;
    max-width: 400px;
    padding: 20px;
  }
}
</style>
